import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'j-snow',
  templateUrl: './snow.component.html',
  styleUrls: ['./snow.component.scss']
})
export class SnowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
